var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { assetPath } from '../../../utils/web-helper';
import { LazyLoadImage } from 'react-lazy-load-image-component';
var prerender = navigator.userAgent && navigator.userAgent.includes("Prerender");
var Image = React.memo(function (_a) {
    var src = _a.src, alt = _a.alt, _b = _a.isCdnImage, isCdnImage = _b === void 0 ? false : _b, props = __rest(_a, ["src", "alt", "isCdnImage"]);
    if (typeof src === "undefined")
        return null;
    return (_jsx(_Fragment, { children: prerender ? _jsx("img", __assign({ src: isCdnImage ? src : assetPath(src), alt: alt }, props)) :
            _jsx(LazyLoadImage, __assign({ src: isCdnImage ? src : assetPath(src), alt: alt }, props)) }));
});
export default Image;
